module.exports = __webpack_public_path__ + "static/media/marker.59b12329.svg";